import { memo, useMemo } from 'react';

import { useStoreSettings, useUserProfile } from 'data-layer';
import { NavbarMenuGroup, NavbarMenuItemData, getNavbarDataByUser } from 'ui/utils';

import { Delimiter } from './Delimiter';
import { MenuGroup } from './MenuGroup';
import { MenuItem } from './MenuItem';

export const filterByUI = (item: NavbarMenuItemData, isNewUIActive: boolean) => {
  return (
    item.showFor === 'both' || (isNewUIActive ? item.showFor === 'newUI' : item.showFor === 'oldUI')
  );
};

export const MobileMenu = memo(() => {
  const { data } = useUserProfile();
  const roles = data?.roles;
  const { data: storeSettings } = useStoreSettings();

  const isNewUIActive = useMemo(() => !!storeSettings?.featureFlags?.enableNewUI, [storeSettings]);

  const { shipping, postShipping, secondaryMenu } = useMemo(() => {
    const { getByGroup } = getNavbarDataByUser({
      roles,
    });
    return {
      shipping: getByGroup([NavbarMenuGroup.shipping]).filter((item) =>
        filterByUI(item, isNewUIActive),
      ),
      postShipping: getByGroup([NavbarMenuGroup.postShipping]).filter((item) =>
        filterByUI(item, isNewUIActive),
      ),
      secondaryMenu: getByGroup([NavbarMenuGroup.secondaryMenu, NavbarMenuGroup.mobile]).filter(
        (item) => filterByUI(item, isNewUIActive),
      ),
    };
  }, [roles]);

  return (
    <>
      <Delimiter />
      <div className="overflow-y-auto h-full">
        <MenuGroup>
          {shipping.map((item) => (
            <MenuItem key={item.id} {...item} />
          ))}
        </MenuGroup>
        {postShipping.length ? (
          <>
            <Delimiter />
            <MenuGroup>
              {postShipping.map((item) => (
                <MenuItem key={item.id} {...item} />
              ))}
            </MenuGroup>
          </>
        ) : null}
        {secondaryMenu.length ? (
          <>
            <Delimiter />
            <MenuGroup>
              {secondaryMenu.map((item) => (
                <MenuItem key={item.id} {...item} />
              ))}
            </MenuGroup>
          </>
        ) : null}
      </div>
    </>
  );
});
